import React from 'react'
import { Clock } from 'lucide-react'
import {
  calculateQuotationDaysLeft,
  formatQuotationDateLong
} from '../DashboardHeader/ConversationalMode/MessageBubble/rubroQuotationTimelineUtils.ts'
import styles from './RubroQuotationDatesStrip.module.scss'

export type RubroQuotationDatesStripProps = {
  windowStartDate: string
  windowEndDate: string
  startLabel?: string
  endLabel?: string
  showDaysLeft?: boolean
  className?: string
}

const RubroQuotationDatesStrip: React.FC<RubroQuotationDatesStripProps> = ({
  windowStartDate,
  windowEndDate,
  startLabel = 'Inicio',
  endLabel = 'Fin',
  showDaysLeft = true,
  className
}) => {
  const startFormatted = formatQuotationDateLong(windowStartDate)
  const endFormatted = formatQuotationDateLong(windowEndDate)
  const daysLeft = calculateQuotationDaysLeft(windowEndDate)

  return (
    <div
      className={[styles.strip, className].filter(Boolean).join(' ')}
      aria-label="Ventana de cotización del rubro"
    >
      <div className={styles.row}>
        <div className={styles.dateItem}>
          <span className={styles.dateLabel}>{startLabel}</span>
          <span className={styles.dateValue}>{startFormatted || '—'}</span>
        </div>
        <div className={styles.divider} aria-hidden />
        <div className={styles.dateItem}>
          <span className={styles.dateLabel}>{endLabel}</span>
          <span className={styles.dateValue}>{endFormatted || '—'}</span>
        </div>
        {showDaysLeft ? (
          <div className={styles.daysLeft}>
            <Clock size={16} aria-hidden />
            <span className={styles.daysLeftValue}>
              {daysLeft === null ? 'No definido' : daysLeft}
            </span>
            <span className={styles.daysLeftCaption}>Días restantes</span>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default RubroQuotationDatesStrip
